import { useMemo } from 'react';
import {
  LanguageChip,
  LanguageChipsWrapper,
  OverflowChip,
  OverflowChipWrapper,
} from './FormManagementLanguageChips.styles';

interface Props {
  languages: string[];
  maxVisible?: number;
  'data-testid'?: string;
}

export const FormManagementLanguageChips = ({
  languages,
  maxVisible = 3,
  'data-testid': dataTestId,
}: Props) => {
  const filteredLanguages = useMemo(
    () => languages.filter((lang) => lang && lang.trim().length > 0),
    [languages],
  );

  const visibleLanguages = useMemo(
    () => filteredLanguages.slice(0, maxVisible),
    [filteredLanguages, maxVisible],
  );

  const overflowCount = useMemo(
    () => Math.max(0, filteredLanguages.length - maxVisible),
    [filteredLanguages.length, maxVisible],
  );

  if (filteredLanguages.length === 0) {
    return null;
  }

  return (
    <LanguageChipsWrapper data-testid={dataTestId}>
      {visibleLanguages.map((lang) => (
        <LanguageChip
          key={lang}
          text={lang}
          size="small"
          readOnly
          hideCloseIcon
          data-testid={dataTestId ? `${dataTestId}-chip-${lang}` : undefined}
        />
      ))}
      {overflowCount > 0 && (
        <OverflowChipWrapper>
          <OverflowChip
            text={`+${overflowCount}`}
            size="small"
            readOnly
            hideCloseIcon
            data-testid={dataTestId ? `${dataTestId}-overflow` : undefined}
          />
        </OverflowChipWrapper>
      )}
    </LanguageChipsWrapper>
  );
};
